import React from "react";
import tw from "tailwind-styled-components";
import {
    InputGroup, SideCancelBtn, SubmitBtn, ActionSection,
    ScrollableContent, FieldWrappers,
    Wrapper,
    ModalHeader
} from "../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import { Formik, Form, Field } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Dropzone from "./Dropzone"
import { toast } from "react-toastify";

const AddNotice = ({

    handleClose
}) => {
    const initialValues = {
        title: "",
        description: "",
        property: "",
        media: "",
    };

    const property = [
        { value: 1, label: "Anuj PG" },
        { value: 2, label: "Super Tech" },
        { value: 3, label: "Bhutani Alphathum" },
        { value: 4, label: "SRS Residency" },
    ];

    const handleSubmit = (values, { resetForm }) => {
        if (!/^(?=.*[A-Za-z]).{3,}$/.test(values.title)) {
            toast.error("Title must be at least 3 characters long and contain at least one alphabet");
            return;
        }
        if (!values.description && !values.media) {
            toast.error("At least one of Description or Media is required");
            return;
        }
        if (!values.property) {
            toast.error("Property Description is required");
            return;
        }
        resetForm();
    };

    return (
        <Container>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Create New Notice</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue }) => (
                        <Form >
                            <ScrollableContent>
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="title">Title *</Label>
                                        <FieldWrappers>
                                            <Field type="text" name="title" id="title" autoComplete="off" required />
                                        </FieldWrappers>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="description">Description </Label>
                                        <FieldWrapper>
                                            <Field
                                                as={Textarea}
                                                id="description"
                                                name="description"
                                                rows={4}

                                            />

                                        </FieldWrapper>
                                    </InputGroup>
                                    <div className=" flex items-center">
                                        <div className="flex-grow border-t border-gray-300"></div>
                                        <span className="mx-4 text-gray-500">OR</span>
                                        <div className="flex-grow border-t border-gray-300"></div>
                                    </div>
                                    <InputGroup>
                                        <Label htmlFor="media">
                                            Media
                                        </Label>
                                        <FieldWrapper $select={true}>
                                            <Field
                                                required
                                                name="media"
                                                type="text"
                                                id="media"
                                                autoComplete="off"
                                            >
                                                {(props) => (
                                                    <Dropzone
                                                        fields={props.field}
                                                        setFieldValue={props.form.setFieldValue}
                                                        componentFor="profile"
                                                        acceptFiles="application/image"
                                                        File={props.field.value ? [props.field.value] : null}
                                                    />
                                                )}
                                            </Field>
                                        </FieldWrapper>
                                        <p className="text-xs text-gray-500 mt-2">Image max size: 10MB</p>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label>Property *</Label>
                                        <Select
                                            id="property"
                                            name="property"
                                            value={values.property}
                                            onChange={(e) => setFieldValue("property", e.target.value)}
                                            className="px-2"
                                            required
                                        >
                                            {property.map((type) => (
                                                <MenuItem key={type.value} value={type.value}>
                                                    {type.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit">Submit</SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>


        </Container>
    );
};


const Title = tw.h1` text-white text-lg  md:text-xl font-medium text-center`;
const BtnWrapper = tw.div`flex justify-center items-center w-full`;
const Textarea = tw.textarea`min-h-30 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-30 resize-y  break-words overflow-hidden`;
const FieldWrapper = tw.div`w-full`;
const BoxContainer = tw.div`bg-white w-full h-full flex flex-col`;
const buttonStyle = `flex justify-end absolute bottom-3 w-full`;
const errormsg = `text-rose-600 text-sm`;
const Content = tw.div`px-4 h-full flex flex-col justify-between pb-4 relative`;
const Label = tw.label`text-sm text-gray-500 font-normal `;
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;


export default AddNotice;
